// @ts-nocheck
/**
 * Wishlist: stores recipe product handles in cart attribute `vhp_wishlist_handles` (comma-separated).
 */
(function () {
  var ATTR = 'vhp_wishlist_handles';
  var LOADING_ATTR = 'data-wishlist-loading';

  function parseHandles(raw) {
    var set = {};
    if (!raw || typeof raw !== 'string') return set;
    raw.split(',').forEach(function (s) {
      var t = s.trim();
      if (t) set[t] = true;
    });
    return set;
  }

  function serializeHandles(set) {
    return Object.keys(set).join(',');
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
      if (!res.ok) throw new Error('cart fetch failed');
      return res.json();
    });
  }

  function setWishlistAttributes(handleMap) {
    var body = { attributes: {} };
    body.attributes[ATTR] = serializeHandles(handleMap);
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    }).then(function (res) {
      if (!res.ok) throw new Error('cart update failed');
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
      return res.json();
    });
  }

  function syncButton(btn, pressed) {
    btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    var onLabel = btn.getAttribute('data-label-on');
    var offLabel = btn.getAttribute('data-label-off');
    if (onLabel && offLabel) {
      btn.setAttribute('aria-label', pressed ? onLabel : offLabel);
    }
  }

  function setButtonLoading(btn, isLoading) {
    if (isLoading) {
      btn.setAttribute(LOADING_ATTR, 'true');
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
    } else {
      btn.removeAttribute(LOADING_ATTR);
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    }
  }

  function setLoadingForHandle(handle, isLoading) {
    document.querySelectorAll('[data-wishlist-toggle][data-product-handle]').forEach(function (b) {
      if (b.getAttribute('data-product-handle') === handle) {
        setButtonLoading(b, isLoading);
      }
    });
  }

  function updateAllButtonsForHandle(handle, pressed) {
    document.querySelectorAll('[data-wishlist-toggle][data-product-handle]').forEach(function (b) {
      if (b.getAttribute('data-product-handle') === handle) {
        syncButton(b, pressed);
      }
    });
  }

  function syncAllFromCart() {
    getCart()
      .then(function (cart) {
        var raw = (cart.attributes && cart.attributes[ATTR]) || '';
        var map = parseHandles(raw);
        document.querySelectorAll('[data-wishlist-toggle][data-product-handle]').forEach(function (btn) {
          var h = btn.getAttribute('data-product-handle');
          syncButton(btn, !!map[h]);
        });
      })
      .catch(function () {});
  }

  function toggle(handle) {
    setLoadingForHandle(handle, true);
    getCart()
      .then(function (cart) {
        var raw = (cart.attributes && cart.attributes[ATTR]) || '';
        var map = parseHandles(raw);
        if (map[handle]) {
          delete map[handle];
        } else {
          map[handle] = true;
        }
        return setWishlistAttributes(map);
      })
      .then(function () {
        return getCart();
      })
      .then(function (cart) {
        var raw = (cart.attributes && cart.attributes[ATTR]) || '';
        var map = parseHandles(raw);
        var pressed = !!map[handle];
        updateAllButtonsForHandle(handle, pressed);
        setLoadingForHandle(handle, false);
      })
      .catch(function () {
        setLoadingForHandle(handle, false);
      });
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (btn.getAttribute(LOADING_ATTR) === 'true' || btn.disabled) return;
      var handle = btn.getAttribute('data-product-handle');
      if (!handle) return;
      toggle(handle);
    },
    true
  );

  document.addEventListener('cart:update', syncAllFromCart);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllFromCart, { once: true });
  } else {
    syncAllFromCart();
  }
})();
